import { Component } from '@angular/core';

import { navItems } from './_nav';
import { ProfileService } from './profile.service';
import { CommonService } from '../../common-service/common.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent {
count:any
  public navItems = navItems;

  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  constructor(private commonservices:CommonService) {
   
  
  }
  ngOnInit() {
    this.commonservices.getenquirycount().then((data: any) => {
      this.count = data;  
      navItems.find((nav)=>nav.name=='Enquiry').badge.text=data
    }) 
    
  }
}
